// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2015." + {"348":"72b4351cca10805a2236","781":"86de11337bd99eadae44","885":"5499d03507be8ffbb84c"}[chunkId] + ".js";
};